import React from "react";
import PropTypes from "prop-types";

// mui
import TablePagination from "@material-ui/core/TablePagination";

export default function Pagination({
    page,
    rowsPerPage,
    total,
    handleChangePage,
    handleChangeRowsPerPage,
    disabled,
}) {
    return (
        <TablePagination
            component="div"
            count={total}
            page={page - 1}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            SelectProps={{ disabled: disabled }}
            backIconButtonProps={disabled ? { disabled: disabled } : undefined}
            nextIconButtonProps={disabled ? { disabled: disabled } : undefined}
        />
    );
}

Pagination.propTypes = {
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    handleChangePage: PropTypes.func.isRequired,
    handleChangeRowsPerPage: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
